import React from 'react'
import Slider from './Slider'
import BreadCrumb from '../BreadCrumb'
import Title from '../Title'
import Main from './Main'
const babyMotherCare = () => {
  return (
    <>
    <Slider /> 
<BreadCrumb heading="Baby & Mother Care" />
<Title heading="Baby & Mother Care"  />
<Main />
</>

  )
}

export default babyMotherCare
